<template>
  <div class="border">
    <h4>Логи # {{ id }}</h4>
    <list
      :columns="columns"
      :modalCreate="modalCreate"
      :removeLink="removeLink"
      :cardLink="cardLink"
      :isAdd="false"
      :itemLink="itemLink"
      title_add=""
      :setLink="setLink"
      :openItem="false"

      :params="params"
      :searchDisable="true"
      @change="change"
      @changeFunction="changeFunction"
      v-model="val"
    />
  </div>
</template>
<script>
export default {
  name: "products",
  methods: {
    changeFunction(val) {},
    change(val) {},
  },
  props: ["id"],
  created() {
    this.itemLink += `/${this.id}/logs`;
    this.setLink += `/${this.id}/logs`;
  },
  data() {
    return {
      params: {},
      val: [],
      modalCreate: "field",

      /** APIs */
      removeLink: "",
      cardLink: "",
      itemLink: "subscriptions",
      setLink: "subscriptions",
      columns: [
        {
          key: "created_at",
          title: "Дата и время",
          checkbox: false,
          control: false,
          align: "left",
          dateTimeFormat: true,
          detail: false,
        },
        {
          key: "name",
          title: "Действие",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "description",
          title: "Описание",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "user",
          title: "",
          object: "name",
          align: "right",
        },
      ],
    };
  },
};
</script>
<style>
</style>
